/* AFS B2B — global behaviors: toasts, drawers, mega menu, quantity steppers,
   AJAX add-to-cart, recently viewed. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var cfg = window.AFSConfig || { routes: {}, pages: {}, features: {} };

  /* ---------- Toast ---------- */
  window.AFSToast = function (message, opts) {
    opts = opts || {};
    var region = document.getElementById('ToastRegion');
    if (!region) return;
    var toast = document.createElement('div');
    toast.className = 'toast' + (opts.tone ? ' toast--' + opts.tone : '');
    toast.textContent = message;
    if (opts.linkHref && opts.linkText) {
      var a = document.createElement('a');
      a.href = opts.linkHref;
      a.textContent = opts.linkText;
      toast.appendChild(a);
    }
    region.appendChild(toast);
    window.setTimeout(function () { toast.remove(); }, opts.duration || 4200);
  };

  /* ---------- Focus trap helper ---------- */
  function trapFocus(container, e) {
    var focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Drawers (mobile nav, filters) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var drawer = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (drawer) {
        drawer.classList.add('is-open');
        drawer.removeAttribute('hidden');
        opener.setAttribute('aria-expanded', 'true');
        drawer.dataset.returnFocus = opener.id || '';
        var closeBtn = drawer.querySelector('[data-drawer-close]');
        if (closeBtn) closeBtn.focus();
      }
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
    if (e.target.classList && e.target.classList.contains('drawer__overlay')) {
      closeDrawer(e.target.closest('.drawer'));
    }
  });

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    var openerId = drawer.dataset.returnFocus;
    var opener = openerId ? document.getElementById(openerId) : document.querySelector('[data-drawer-open="' + drawer.id + '"]');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }

  document.addEventListener('keydown', function (e) {
    var openDrawer = document.querySelector('.drawer.is-open');
    if (openDrawer) {
      if (e.key === 'Escape') closeDrawer(openDrawer);
      if (e.key === 'Tab') trapFocus(openDrawer.querySelector('.drawer__panel') || openDrawer, e);
    }
    if (e.key === 'Escape') closeMegaPanels();
  });

  /* ---------- Mega menu ---------- */
  function closeMegaPanels(except) {
    document.querySelectorAll('.main-nav [data-mega-toggle]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel && panel !== except) {
        btn.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      }
    });
  }

  document.querySelectorAll('[data-mega-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      closeMegaPanels(panel);
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-wrap')) closeMegaPanels();
  });

  /* ---------- Mobile nav accordions & generic disclosure buttons ---------- */
  document.querySelectorAll('[data-disclosure]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      target.hidden = expanded;
    });
  });

  /* ---------- Quantity steppers with pack/increment rules ---------- */
  function clampQty(input) {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || Infinity;
    var step = parseInt(input.step, 10) || 1;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) val = min;
    if (val > max) val = max;
    var remainder = (val - min) % step;
    if (remainder !== 0) val = val + (step - remainder); // round up to next allowed multiple
    if (val > max) val = max - ((max - min) % step);
    input.value = val;
    return val;
  }

  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn) return;
    var wrap = stepBtn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(input.step, 10) || 1;
    var dir = stepBtn.getAttribute('data-qty-step') === 'up' ? 1 : -1;
    input.value = (parseInt(input.value, 10) || 0) + dir * step;
    clampQty(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('.qty input, input[data-qty-rules]')) clampQty(e.target);
  });

  /* ---------- AJAX add to cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.setAttribute('data-count', String(count));
    });
  }

  window.AFSCart = {
    add: function (items) {
      return fetch(cfg.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return fetch(cfg.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('afs:cart-updated', { detail: cart }));
          return cart;
        });
      });
    }
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var variantId = parseInt((form.querySelector('[name="id"]') || {}).value, 10);
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? clampQty(qtyInput) : 1;
    if (!variantId) return;
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding-text') || '…'; }
    window.AFSCart.add([{ id: variantId, quantity: qty }])
      .then(function () {
        window.AFSToast(form.getAttribute('data-added-text') || 'Added to cart', {
          tone: 'success', linkHref: cfg.routes.cart, linkText: form.getAttribute('data-view-cart-text') || 'View cart'
        });
      })
      .catch(function (err) {
        window.AFSToast((err && err.description) || 'Unable to add to cart', { tone: 'error' });
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      });
  });

  /* ---------- Recently viewed (PDP records; section renders) ---------- */
  var RV_KEY = 'afs:recently-viewed';
  window.AFSRecentlyViewed = {
    record: function (handle) {
      try {
        var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
      } catch (e) { /* storage unavailable */ }
    },
    get: function () {
      try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
    }
  };

  /* ---------- Tabs (accessible, used where details/summary not suitable) ---------- */
  document.querySelectorAll('[role="tablist"]').forEach(function (tablist) {
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (e) {
        var next;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (next) { e.preventDefault(); next.focus(); activate(next); }
      });
    });
    function activate(tab) {
      tabs.forEach(function (t) {
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        var active = t === tab;
        t.setAttribute('aria-selected', String(active));
        t.tabIndex = active ? 0 : -1;
        if (panel) panel.hidden = !active;
      });
    }
  });
})();
